import { render, staticRenderFns } from "./CultureNewMediaRegisterInfo.vue?vue&type=template&id=16f00ef8&scoped=true&"
import script from "./CultureNewMediaRegisterInfo.vue?vue&type=script&lang=js&"
export * from "./CultureNewMediaRegisterInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f00ef8",
  null
  
)

export default component.exports